import { useIntl } from 'react-intl';

import { Dropdown } from 'components/Forms';

interface ITagsProps {
  handleChange: any;
  options: ISelectOption[];
  value: ISelectOption[];
}

const Tags = ({ handleChange, options, value }: ITagsProps) => {
  const intl = useIntl();

  return (
    <Dropdown
      dataTestId="filter-tags"
      variant="form"
      options={options}
      placeholder={intl.formatMessage({ id: 'selectTagKey' })}
      onChange={handleChange}
      isMulti
      value={value}
      isClearable={false}
      useImage
      minWidth={200}
      label={intl.formatMessage({ id: 'tagsKey' })}
    />
  );
};

export default Tags;
